import {useTranslation} from "react-i18next";

export function ContactItem({contact, LinkFactory}){
  const {id,img, firstname, lastname, extra_data} = contact;

  let span;
  let contact_img;

  if (extra_data.profession !== null && extra_data.full_mandat !== null) {
    span = <span>{extra_data.profession} | {extra_data.full_mandat}</span>
  }else if(extra_data.full_mandat === null){
    span = <span>{extra_data.profession}</span>
  }

  if(img === undefined || img === null){
    contact_img = <span className="c-contact_img-replace">{firstname[0].toUpperCase()}{lastname[0].toUpperCase()}</span>
  }else{
    contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={img} />
  }


  return (
    <LinkFactory id={id} type={"contact"}>
      <div className={`c-contact ${id}`}>
        {contact_img}
        <div className="c-infos">
          <p>{firstname} {lastname}</p>
          { span }
        </div>
      </div>
    </LinkFactory>
  )
};


function sortContact(data){
  return data.sort(function(a,b){

    var nameA = a.lastname.toUpperCase().replace('É','E');
    var nameB = b.lastname.toUpperCase().replace('É','E');

    if(nameA > nameB){
      return 1;
    }
    if( nameA < nameB){
      return -1;
    }
    return 0;
  });
}

export function ContactListClassic({contacts, LinkFactory}){
    const { t } = useTranslation();
    let data = sortContact(contacts);

  if(data.length === 0) {
    return (
      <>
        <p>{t('Aucun élément à afficher')}</p>
      </>
    )
  }else{
    return (
        <>
          <div className="c-contact_list-letter title">
            {data.map(i => <ContactItem key={i.id} contact={i} LinkFactory={LinkFactory} />)}
          </div>
        </>
    )
  }
}

export function ContactList({contacts, LinkFactory}){
  const { t } = useTranslation();
  let data = sortContact(contacts);
  if(data.length === 0){
    return (
      <>
        <p>{t('Aucun élément à afficher')}</p>
      </>
    )
  }else{
    let firstLetter = data[0].lastname.charAt(0).toUpperCase();

    let contactGrp = [{letter: firstLetter,data:[]}];
    data.map((item)=> {
      let titleLetter = item.lastname[0].toUpperCase().replace('É','E');
      if(firstLetter.toUpperCase() !== titleLetter.toUpperCase()){
        firstLetter = titleLetter;
        contactGrp.push({letter: firstLetter.toUpperCase(), data:[item]});
       }else{
        contactGrp.map((i) => {
            if(i.letter.toUpperCase() === firstLetter.toUpperCase()){
                return i.data.push(item);
            }
            return null;
        });
       }
      return null;
     });
    return (
      <>
        {contactGrp.map(c => {
          return(
            <div className="c-contact_list-letter title" key={contactGrp.indexOf(c)}>
              <h3 key={c.letter} className="c-contact_letter">{c.letter}</h3>
              {c.data.map(i => <ContactItem key={i.id} contact={i} LinkFactory={LinkFactory} />)}
            </div>);
        })}
      </>
    )
  }
};
export default ContactList
